import { sleep, makeId } from "./mock";

// Helper: ISO date builders for mock data
const now = new Date();
const iso = (d) => d.toISOString();
const addMonths = (d, m) =>
  new Date(d.getFullYear(), d.getMonth() + m, d.getDate());
const addDays = (d, n) =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);

export async function GetLicensesTrends() {
  const response = await fetch("https://hs2api.razamit.pl/licenseStats", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      "Error:".errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}
export async function GetRPTData() {
  const response = await fetch("https://hs2api.razamit.pl/rptList", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    return null;
    // const error = new Error('Error:'. errorData.error || 'Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.');
    // error.status = response.status;
    //  throw errorData;
  }

  const data = await response.json();

  return data;
}
async function sendSubscriptionRequest(endpoint, id) {
  // console.log(`Wysyłam dane do ${endpoint}:`, id);

  const response = await fetch(`https://hs2api.razamit.pl/${endpoint}`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ subscriberID: id }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      errorData.error ||
        "Błąd w zapytaniu. Popraw zapytanie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();
  return { data };
}

export const DisableSubscription = (id) =>
  sendSubscriptionRequest("disableSubscription", id);
export const RenwSubscription = (id) =>
  sendSubscriptionRequest("renewSubscription", id);
export const SetFVRozliczenie = (id) =>
  sendSubscriptionRequest("rozliczFV", id);

export async function GetLicensesListGenereated() {
  const response = await fetch("https://hs2api.razamit.pl/getGLicenses", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}

export async function GetLicensesListGenereatedTest() {
  const response = await fetch("https://hs2api.razamit.pl/getGLicensesTest", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}
export async function GetLicensesList(filter = "p") {
  const response = await fetch("https://hs2api.razamit.pl/subscribersList", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      filter: filter,
      tag: "nomal",
      worker: "all",
      licActive: "all",
      searchField: "",
      subStatus: "all",
      subRodzaj: "all",
      licRodzaj: "all",
      userId: "0",
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}

let LICENSES = [
  {
    id: "l1",
    name: "HShop Pro",
    seats: 25,
    assigned: 12,
    price: 1499,
    currency: "PLN",
    clientName: "Sklep Alfa Sp. z o.o.",
    clientId: "C001",
    accountManager: "Anna Kowalska",
    expiresAt: iso(addDays(now, 10)),
    renewedAt: iso(addDays(now, -2)), // odnowione w tym miesiącu
    renewalFee: 100, // opłata za przedłużenie
  },
  {
    id: "l2",
    name: "HShop Basic",
    seats: 100,
    assigned: 60,
    price: 4999,
    currency: "PLN",
    clientName: "Market Beta S.A.",
    clientId: "C002",
    accountManager: "Jan Nowak",
    expiresAt: iso(addMonths(now, 1)),
    renewedAt: null, // brak odnowienia w tym miesiącu
    renewalFee: 100,
  },
  {
    id: "l3",
    name: "HShop Enterprise",
    seats: 200,
    assigned: 200,
    price: 15999,
    currency: "PLN",
    clientName: "Retail Gamma sp.k.",
    clientId: "C003",
    accountManager: "Anna Kowalska",
    expiresAt: iso(addDays(now, -5)), // już wygasła
    renewedAt: iso(addMonths(now, -2)),
    renewalFee: 100,
  },
  {
    id: "l4",
    name: "HShop Pro",
    seats: 50,
    assigned: 20,
    price: 2999,
    currency: "PLN",
    clientName: "Outlet Delta s.c.",
    clientId: "C004",
    accountManager: "Piotr Kubiak",
    expiresAt: iso(addMonths(now, 0)), // wygasa w tym miesiącu
    renewedAt: null,
    renewalFee: 100,
  },
  {
    id: "l5",
    name: "HShop Basic",
    seats: 30,
    assigned: 15,
    price: 1999,
    currency: "PLN",
    clientName: "Firma 123456",
    clientId: "123456",
    accountManager: "Jan Nowak",
    expiresAt: iso(addMonths(now, 2)),
    renewedAt: iso(addDays(now, -5)), // odnowione w tym miesiącu
    renewalFee: 100,
  },
  {
    id: "l6",
    name: "HShop Pro",
    seats: 40,
    assigned: 30,
    price: 2499,
    currency: "PLN",
    clientName: "Sklep Alfa Sp. z o.o.",
    clientId: "C001",
    accountManager: "Anna Kowalska",
    expiresAt: iso(addMonths(now, 1)),
    renewedAt: iso(addDays(now, -10)), // odnowione w tym miesiącu
    renewalFee: 100,
  },
];

let ASSIGNMENTS = [
  { id: makeId(), userId: "1", licenseId: "l1" },
  { id: makeId(), userId: "2", licenseId: "l2" },
];

export async function listLicenses() {
  await sleep(400);
  return [...LICENSES];
}

export async function listAssignments() {
  await sleep(400);
  return [...ASSIGNMENTS];
}

export async function assignLicense(userId, licenseId) {
  await sleep(500);
  const exists = ASSIGNMENTS.find(
    (a) => a.userId === userId && a.licenseId === licenseId,
  );
  if (exists) return exists;
  const assignment = { id: makeId(), userId, licenseId };
  ASSIGNMENTS.push(assignment);
  LICENSES = LICENSES.map((l) =>
    l.id === licenseId ? { ...l, assigned: l.assigned + 1 } : l,
  );
  return assignment;
}

export async function revokeLicense(assignmentId) {
  await sleep(500);
  const removed = ASSIGNMENTS.find((a) => a.id === assignmentId);
  ASSIGNMENTS = ASSIGNMENTS.filter((a) => a.id !== assignmentId);
  if (removed) {
    LICENSES = LICENSES.map((l) =>
      l.id === removed.licenseId
        ? { ...l, assigned: Math.max(0, l.assigned - 1) }
        : l,
    );
  }
  return { ok: true };
}

export async function updateLicense(id, payload) {
  try {
    const response = await fetch(
      "https://hs2api.razamit.pl/editsubscriber/" + id,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}
export async function SendEmail() {
  try {
    const response = await fetch("https://hs2api.razamit.pl/sendemail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}

export async function SaveIntegraationData(id, selectedIds) {
  try {
    const response = await fetch("https://hs2api.razamit.pl/saveSelectedIds", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, selectedIds }),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}
export async function UpdateActivationCompetitionProduct(prodId, activeStatus) {
  try {
    const response = await fetch(
      "https://hs2api.razamit.pl/updateActivationCompetitionProduct",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ prodId, activeStatus }),
      },
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd aktualizacji stanu indeksu konkurencjii:", err);
    throw err;
  }
}

export async function SaveAditionalModuleData(id, selectedIds) {
  try {
    const response = await fetch(
      "https://hs2api.razamit.pl/saveSelectedIdsAditionalModule",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, selectedIds }),
      },
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}

export async function SaveConcurentPlatformsData(id, selectedIds) {
  try {
    console.log("Wysyłam dane do saveSelectedIdsConcurentPlatforms:", {
      id,
      selectedIds,
    });
    const response = await fetch(
      "https://hs2api.razamit.pl/saveSelectedIdsConcurentPlatforms",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, selectedIds }),
      },
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}

export async function RefrechLicense(payload) {
  try {
    const response = await fetch("https://hs2api.razamit.pl/refreshLicense", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}
export async function changesubscriberLicensefvOrNot(payload) {
  try {
    const response = await fetch(
      "https://hs2api.razamit.pl/changesubscriberLicensefvOrNot",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}
export async function ClearDatabasePOST() {
  try {
    const response = await fetch(
      "https://hs2api.razamit.pl/clearDatabaseGenerated",
      {
        method: "POST",
        credentials: "include",
      },
    );
    if (!response.ok) {
      return { status: false, message: "Błąd usuwania danych" };
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}
export async function createLicense(payload) {
  try {
    const response = await fetch("https://hs2api.razamit.pl/license", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}
export async function createKeyList(payload) {
  try {
    const response = await fetch("https://hs2api.razamit.pl/createHashKeys", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}
export async function getExportList(payload) {
  try {
    const response = await fetch("https://hs2api.razamit.pl/getExportList", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia licencji:", err);
    throw err;
  }
}

export async function SendLicense(userId) {
  const response = await fetch("https://hs2api.razamit.pl/genereLicense", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ subscriberId: userId }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}
export async function SendOneMoreTime(userId) {
  const response = await fetch(
    "https://hs2api.razamit.pl/OneMoreTimeSendLicense",
    {
      method: "POST",

      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ subscriberId: userId }),
    },
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}

export async function deleteLicense(id) {
  const response = await fetch("https://hs2api.razamit.pl/deletelicense", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ license: id }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }
  const data = await response.json();
  return { data };
}
